import { deleteCurrentLogo, redoLogo, scene, undoLogo, updateDecals } from './webGL';

export function pushUndoQueue() {
  updateDecals();
  redoLogo && (redoLogo.length = 0);

  if (window.decals.length === 0) return;

  const logoAction = [];
  window.decals.forEach((x) => {
    logoAction.push(convertLogoData(x));
  });
  undoLogo.push(logoAction);
}

export function convertLogoData(value) {
  const Position = Object.assign(
    Object.create(Object.getPrototypeOf(value?.logo?.Position)),
    value?.logo?.Position,
  );
  const Orientation = Object.assign(
    Object.create(Object.getPrototypeOf(value?.logo?.Orientation)),
    value?.logo?.Orientation,
  );
  const rotate = value.logo.Rotate;
  const scale = value.logo.Scale;
  return {
    type: 'logo',
    value,
    Position,
    Orientation,
    rotate,
    scale,
  };
}

export function doUndoLogo() {
  if (undoLogo.length === 0) return;
  if (undoLogo.length === 1) {
    const lastAction = undoLogo.pop();
    redoLogo.push(lastAction);
    let _logo = [];
    scene.children.forEach((x) => {
      if (x.logo != null) {
        _logo.push(x);
      }
    });
    _logo.forEach((x) => {
      scene.remove(x);
    });
    window.decals = [];
    return;
  }
  const lastAction = undoLogo.pop();
  redoLogo.push(lastAction);
  const current = undoLogo[undoLogo.length - 1];
  syncTheDecals(current);
}

export function syncTheDecals(currentAction) {
  window.decals.forEach((d) => {
    scene.remove(d);
  });
  window.decals = [];

  currentAction.forEach((d) => {
    d.value.logo.Rotate = d.rotate;
    d.value.logo.Scale = d.scale;
    d.value.logo.decalMesh = d.value;
    scene.add(d.value);
    window.decals.push(d.value);
  });
}

export function doRedoLogo() {
  if (redoLogo?.length > 0) {
    const lastAction = redoLogo.pop();
    undoLogo.push(lastAction);
    syncTheDecals(lastAction);
  }
}

export function doTheDelete() {
  if (window.currentLogo == null) return;
  if (window.currentLogo.IsText == true) return;
  if (window.currentLogo.IsPattern == true) return;

  deleteCurrentLogo();
  window.currentLogo = null;
  pushUndoQueue();
}
